export default __webpack_public_path__ + "static/media/Series-7000-Inline.1467f119.png";